"use client";

import { getThumbnail } from "@tosize/ui";
import Image from "~/components/utilities/Image";
import type { DIYProjectCardProps } from "./Index";

export function DIYProjectCardImage(props: Pick<DIYProjectCardProps, "lang" | "project">) {
	return (
		<>
			{props.project.images[0] && (
				<Image
					src={getThumbnail(props.project.images[0], props.lang, "watermark_800x450")}
					alt={props.project.title ?? ""}
					width={800}
					height={450}
					className="aspect-[800/450]"
				/>
			)}
			{props.project.images.length >= 2 && props.project.images[1] && (
				<div className="absolute inset-0 opacity-0 motion-safe:transition-opacity motion-safe:duration-300 sm:group-focus-visible:opacity-100 sm:group-hover:opacity-100">
					<Image
						src={getThumbnail(props.project.images[1], props.lang, "watermark_800x450")}
						alt={props.project.title ?? ""}
						width={800}
						height={450}
						className="aspect-[800/450]"
					/>
				</div>
			)}
		</>
	);
}
